import { Grid } from "@mui/material";
import SearchableSelect, {
  SelectOption,
} from "app/components/SearchableSelect";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectActualInstructor } from "store/global/fields/selector";
import { actions } from "store/global/fields/slice";
import { useStyles } from "../styles";
interface TProps {
  value: number;
  treatmentId: number;
  bankId: number;
  instructorId: number;
  changeValue: (value: number) => void;
  disabled?: boolean;
  showAll: boolean;
  isEdit: boolean;
  xs?: number;
}
const ActualInstructorField = (props: TProps) => {
  const dispatch = useDispatch();
  const styles = useStyles();
  const List = useSelector(selectActualInstructor);

  const { t } = useTranslation();

  useEffect(() => {
    if (props.showAll) {
      dispatch(
        actions.getActualInstructorList({
          treatmentId: props.treatmentId,
          bankId: props.bankId,
        })
      );
    } else if (props.treatmentId > 0) {
      dispatch(
        actions.getActualInstructorList({
          treatmentId: props.treatmentId,
          bankId: props.bankId,
        })
      );
    } else {
      dispatch(actions.getActualInstructorListSuccess({ items: [] }));
    }

    return () => {};
  }, [props.treatmentId, props.bankId]);

  const options: SelectOption[] = List.items.map((item: any) => ({
    label: `${item.firstName} ${item.lastName}`,
    value: item.id,
    raw: item,
  }));

  return (
    <Grid item xs={props.xs ? props.xs : 2}>
      <label className={styles.label}>
        {t("TIMESLOT.ACTUAL_INSTRUCTOR_NAME")}
      </label>
      <SearchableSelect
        options={options}
        value={props.value ?? ""}
        onChange={(val) => props.changeValue(Number(val))}
        disabled={props.disabled}
        searchable
        className={styles.textEnabled}
        showAllOption={
          props.showAll ? { label: t("COMMON.ALL"), value: 0 } : undefined
        }
      />
    </Grid>
  );
};
export default ActualInstructorField;
